export default __webpack_public_path__ + "static/media/emmanuel.893700dc.svg";